import { useRef } from 'react';

import { useIsClamped } from '@crm/shared/lib';
import { formatPrice } from '@shared/helpers';

import { TDeal } from '../../model/deal';

export const DealCardSubtitle = ({
    customerName,
    budget,
}: {
    customerName: TDeal['customerName'];
    budget: TDeal['approximateBudget'];
}) => {
    const budgetText =
        Number(budget) > 0 ? formatPrice(Number(budget), { withCurrency: true }) : '';

    const subtitleRef = useRef<HTMLParagraphElement>(null);
    const isClamped = useIsClamped(subtitleRef);

    const subtitleText = `${customerName} ${budgetText && `| ${budgetText}`}`;
    return (
        <h5
            className="text-smtr-main-tertiary-100 line-clamp-1"
            title={isClamped ? subtitleText : undefined}
            ref={subtitleRef}
        >
            {subtitleText}
        </h5>
    );
};
